import React from "react";

const Footer = () => {
  return (
    <footer className="section bg-dark text-white pt-5 pb-3">
      <div className="container">
        <div className="row text-center text-md-start text-lg-start">
          {/* Logo & About */}
          <div className="col-md-3 mb-3">
            <h5 className="text-center text-md-start">
              <img
                className="bottom-logo"
                src="assets/images/logo-dark.png"
                alt="Fexila Logo"
                width="120"
              />
            </h5>

            <p className="bottom-sub">
              Simplifying eCommerce with flexible content management,
              subscriptions, and seamless scalability.
            </p>
            <div className="footer-social">
              <a href="#">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="#">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#">
                <i className="bi bi-google"></i>
              </a>
            </div>
          </div>

          {/* Company News */}
          <div className="col-md-3 mb-3 news">
            <h5>Company News</h5>
            <ul className="list-unstyled">
              <li>
                <a href="https://fexila.com/privacy" style={{ color: "#ccc" }}>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://fexila.com/terms" style={{ color: "#ccc" }}>
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Useful Links */}
          <div className="col-md-3 mb-3 links">
            <h5>Useful Links</h5>
            <ul className="list-unstyled">
              <li>
                <a href="#features" className="text-decoration-none">
                  Features
                </a>
              </li>
              <li>
                <a href="#faqs" className="text-decoration-none">
                  Faqs
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-decoration-none">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#contact" className="text-decoration-none">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 mb-3 footer-social footer-social-md">
            <h5>Contact Us</h5>
            <ul className="list-unstyled">
              <li className="d-flex align-items-center mb-3">
                <span className="f-contact me-2">
                  <i className="bi bi-telephone-fill"></i>
                </span>
                <span>1800-121-3637 | +91 555 234-8765</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <span className="f-contact me-2">
                  <i className="bi bi-envelope-fill"></i>
                </span>
                <span>info@fexila.com</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <span className="f-contact me-2">
                  <i className="bi bi-geo-alt-fill"></i>
                </span>
                <span>380 St Kilda Road, Melbourne VIC 3004, Australia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <p className="text-center mt-4">© 2025 Fexila. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
